import { render, staticRenderFns } from "./LmPageBreak.vue?vue&type=template&id=bc6d0c2e"
import script from "./LmPageBreak.vue?vue&type=script&lang=js"
export * from "./LmPageBreak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports